module.exports = __webpack_public_path__ + "img/clock.8db3bc86.png";